<!-- Titolo -->
<div class="ui-g-12 campaign-step-title flex-align-center">
  <div class="ui-g-12 ui-md-8">
    <h2 *ngIf="campaignId" class="step-title">{{ 'common.edit' | translate }} {{ 'campaign.campaign' | translate }}</h2>
    <h2 *ngIf="!campaignId" class="step-title">{{ 'common.ts_ins' | translate }} {{ 'campaign.newCampaign' | translate }}</h2>
  </div>
  <div class="ui-g-12 ui-md-4 text-right">
    <button
      pButton
      type="button"
      class="k-generic-btn"
      icon="fa fa-angle-left"
      iconPos="left"
      label="{{ 'common.back' | translate }}"
      [routerLink]="'/campaign-list-2'">
    </button>
  </div>
</div>
<div class="ui-g-12">
  <div class="ui-g-12">
    <form id="campaign-detail-form" *ngIf="form && campaignFields" [formGroup]="form" [ngClass]="{'invalid-submit': invalidSubmit}">
      <!-- Nome campagna -->
      <section class="ui-g-12">
        <h3 class="section-title label" [ngClass]="{'required': !campaignFields.name.nullable}">
          {{ 'campaign.newCampaignName' | translate }}
        </h3>
        <div class="ui-g-12 ui-md-6">
          <input type="text" pInputText class="fieldInput" formControlName="name" style="width: 100%;">
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="campaignFields.name"></app-validation-msg>
        </div>
      </section>
      <!-- Descrizione campagna -->
      <section class="ui-g-12">
        <h3 class="section-title label" [ngClass]="{'required': !campaignFields.description.nullable}">
          {{ 'campaign.newCampaignDesc' | translate }}
        </h3>
        <div class="ui-g-12 ui-md-6">
          <textarea
            type="text"
            pInputTextarea
            class="fieldInput"
            formControlName="description"
            style="resize: none; width: 100%; padding: 15px;"
            rows="7">
          </textarea>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="campaignFields.description"></app-validation-msg>
        </div>
      </section>
      <!-- Validità Campagna -->
      <section class="ui-g-12">
        <h3 class="section-title">
          {{ 'campaign.newCampaignValidity' | translate }}
        </h3>
        <div class="ui-g-12 ui-md-6">
          <label [ngClass]="{'required': !campaignFields.start_date.nullable}">{{ 'common.date_start' | translate }}</label>
          <app-kv-calendar
            #dateStartField
            [inputName]="'start_date'"
            [formData]="form"
            [startDateSelector]="true"
            [endDateInputName]="'end_date'"
            [endDateCalendar]="dateEndField"
            [defaultDate]="form.get('start_date').value || today"
            [defaultValue]="setStartDate()">
          </app-kv-calendar>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="campaignFields.start_date"></app-validation-msg>
        </div>
        <div class="ui-g-12 ui-md-6">
          <label [ngClass]="{'required': !campaignFields.end_date.nullable}">{{ 'common.date_end' | translate }}</label>
          <app-kv-calendar
            #dateEndField
            [inputName]="'end_date'"
            [formData]="form"
            [endDateSelector]="true"
            [startDateInputName]="'start_date'"
            [startDateCalendar]="dateStartField"
            [defaultDate]="setEndDate(dateEndField)"
            [defaultValue]="setEndDate(dateEndField)">
          </app-kv-calendar>
          <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="campaignFields.end_date"></app-validation-msg>
        </div>
      </section>
      <!-- Budget -->
      <section class="ui-g-12">
        <h3 class="section-title">
          {{ 'campaign.newCampaignBudget' | translate }}
        </h3>
         <!-- Tipo di Budget -->
        <div class="ui-g-12 ui-md-6">
            <label class="top-label" [ngClass]="{'required': !campaignFields.budget_type_id.nullable}">{{ campaignFields.budget_type_id.keyName }}</label>
            <div>
              <p-dropdown
                *ngIf="budgetType && budgetType.length > 0"
                [style]="{'width':'80%'}"
                [options]="budgetType"
                formControlName="budget_type_id"
                [placeholder]="'campaign.budgetType' | translate">
              </p-dropdown>
              <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="campaignFields.budget_type_id"></app-validation-msg>
            </div>
        </div>
        <!-- Valore Budget -->
        <div class="ui-g-12 ui-md-6">
          <label class="top-label" [ngClass]="{'required': !campaignFields.budget.nullable}">{{ campaignFields.budget.keyName }}</label>
          <div>
            <div class="budget-input-container">
              <p-spinner [thousandSeparator]="'.'" [min]="0" formControlName="budget" [inputStyle]="{'padding-left': '16px'}"></p-spinner>
              <span class="budget-currency">€</span>
            </div>
            <app-validation-msg [(fireInvalidSubmit)]="invalidSubmit" [form]="form" [validation]="campaignFields.budget"></app-validation-msg>
          </div>
        </div>
      </section>
      <!-- Salva Campagna -->
      <section class="ui-g-12" style="padding-bottom: 100px;">
        <div class="ui-g-12 text-right">
          <button
            pButton
            (click)="save()"
            type="button"
            class="k-generic-btn"
            label="{{ 'common.save' | translate }}">
          </button>
        </div>
      </section>
    </form>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-2.0/campaign-detail2/campaign-detail2.component.html